import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { BONOS } from './salesData';
export function BonosSection() {
  return <section className="bg-cream py-16 sm:py-24" data-id="element-38" data-mp="13d4dyg5nrpnq">
      <div className="mx-auto max-w-5xl px-5" data-id="element-39" data-mp="13btegsj8x42f">
        <div className="text-center" data-id="element-40" data-mp="yfmedgdj6mse">
          <SectionTag data-id="element-41" data-mp="yekt6j2swjwy">🎁 4 Bonos estratégicos</SectionTag>
          <h2 className="mt-4 font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-42" data-mp="tfzzz3lyv0i0">
            Siempre incluidos
          </h2>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-43" data-mp="oirhf1wwoug8">
          {BONOS.map((bono, i) => <motion.article key={bono.num} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="relative flex gap-4 rounded-2xl border border-rose/10 bg-white p-6 shadow-sm" data-id="element-44" data-mp="kh5xiwlyffwj" data-mpi={i}>
              <span className="font-display text-4xl font-black text-rose/25" data-id="element-45" data-mp="qu38ph5z68bd">{bono.num}</span>
              <div className="flex-1" data-id="element-46" data-mp="vw2cut9jh99d">
                <div className="flex items-center gap-2" data-id="element-47" data-mp="huq00qpodnrp">
                  <GiftIcon className="h-4 w-4 text-rose" data-id="element-48" data-mp="hwated0970nz" />
                  <h3 className="font-display text-lg font-bold text-ink" data-id="element-49" data-mp="mtb1sukksfi9">
                    Bono {bono.num} — {bono.title}
                  </h3>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-50" data-mp="1alrjv54bc7hk">{bono.desc}</p>
                <p className="mt-3 text-sm" data-id="element-51" data-mp="1en37j53mmin4">
                  <span className="text-ink/40 line-through" data-id="element-52" data-mp="10udlx1s0ffqj">{bono.value}</span>{' '}
                  <span className="font-bold uppercase text-rose-deep" data-id="element-53" data-mp="15s5e7wwkh3v9">Gratis</span>
                </p>
              </div>
            </motion.article>)}
        </div>

        <div className="mt-8 rounded-2xl bg-rose px-6 py-5 text-center text-white shadow-lg shadow-rose/25" data-id="element-54" data-mp="1tgetsh36svdy">
          <p className="text-base font-semibold sm:text-lg" data-id="element-55" data-mp="284yi48btzktp">
            Valor total bonos <span className="line-through opacity-70" data-id="element-56" data-mp="282vntc3nb5j6">$71.960</span> →{' '}
            <span className="font-black" data-id="element-57" data-mp="236eqbrak3etf">GRATIS con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}